import type { Cell, LevelConfig } from "./types.js";

export function createBoard(size: number): Cell[][] {
  return Array.from({ length: size }, () =>
    Array.from({ length: size }, () => 0 as Cell)
  );
}

export function placeMark(
  board: Cell[][],
  r: number,
  c: number,
  player: 1 | 2
): { ok: true; board: Cell[][] } | { ok: false; reason: string } {
  const size = board.length;
  if (r < 0 || r >= size || c < 0 || c >= size) return { ok: false, reason: "Invalid cell." };
  if (board[r][c] !== 0) return { ok: false, reason: "Cell already taken." };
  const copy = board.map((row) => [...row]);
  copy[r][c] = player;
  return { ok: true, board: copy };
}

export function checkWinner(
  board: Cell[][],
  connect: number
): { winner: 0 | 1 | 2; cells: Array<{ r: number; c: number }> } {
  const size = board.length;
  const dirs: Array<[number, number]> = [
    [1, 0],
    [0, 1],
    [1, 1],
    [1, -1],
  ];

  for (let r = 0; r < size; r++) {
    for (let c = 0; c < size; c++) {
      const piece = board[r][c];
      if (piece === 0) continue;
      for (const [dr, dc] of dirs) {
        const cells: Array<{ r: number; c: number }> = [{ r, c }];
        let rr = r;
        let cc = c;
        for (let i = 1; i < connect; i++) {
          rr += dr;
          cc += dc;
          if (rr < 0 || rr >= size || cc < 0 || cc >= size) break;
          if (board[rr][cc] !== piece) break;
          cells.push({ r: rr, c: cc });
        }
        if (cells.length === connect) return { winner: piece, cells };
      }
    }
  }

  return { winner: 0, cells: [] };
}

export function isBoardFull(board: Cell[][]): boolean {
  return board.every((row) => row.every((cell) => cell !== 0));
}
